export default "__VITE_ASSET__CJK16ruP__"